var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.25 1.62132C12.447 1.42434 12.6808 1.26808 12.9382 1.16148C13.1956 1.05487 13.4714 1 13.75 1C14.0286 1 14.3044 1.05487 14.5618 1.16148C14.8192 1.26808 15.053 1.42434 15.25 1.62132C15.447 1.8183 15.6032 2.05216 15.7098 2.30953C15.8165 2.5669 15.8713 2.84274 15.8713 3.12132C15.8713 3.3999 15.8165 3.67574 15.7098 3.93311C15.6032 4.19048 15.447 4.42434 15.25 4.62132L5.125 14.7463L1 15.8713L2.125 11.7463L12.25 1.62132Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/edit-white.c801624593c1a7579a9e2f3ae27dd56e.svg";
export { ForwardRef as ReactComponent };